import {Station} from "../model/Station";

/**
 * The backend applies a write to Firestore, then an asynchronous trigger
 * recomputes/updates the station and syncs it to the stations API (a few
 * seconds). Since the web reads that API (no more live Firestore updates), a
 * refresh fired right after an action still returns the OLD data.
 *
 * After any action that modifies the displayed station, poll the refresh until
 * the returned station differs from the pre-action snapshot — whatever the
 * change (new price date, fuel added or removed, station fields...). Gives up
 * silently after `attempts` polls: the UI then simply keeps the current data,
 * exactly as before this helper existed.
 */
export async function refreshUntilStationChanged(
    before: Station,
    refresh?: () => void | Promise<Station | void>,
    attempts = 5,
    intervalMs = 1500,
): Promise<void> {
    if (!refresh) { return; }
    const baseline = JSON.stringify(before);
    for (let attempt = 0; attempt < attempts; attempt++) {
        await new Promise(resolve => setTimeout(resolve, intervalMs));
        const refreshed = await refresh();
        if (refreshed && JSON.stringify(refreshed) !== baseline) { return; }
    }
}
